import { z } from 'zod';
import { ROLES } from '../enums.js';
import { emailSchema } from './auth.js';
export const addMemberSchema = z.object({
    email: emailSchema,
    role: z.enum(ROLES).default('STAFF'),
});
//# sourceMappingURL=memberships.js.map